const MessageBusTransactionType = {
	MODAL: "modal",
	PAGE_LOAD_START: "page-load-start",
	PAGE_LOAD_STOP: "page-load-stop",
}

export default MessageBusTransactionType;
